const header = document.querySelector('.header');


/* nav bar */
$(document).ready(function() {

  $('#heygen-streaming-embed').hide();
  $("#heygen-streaming-container").before('<div class="chat-close"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></div>');


    function handleDropdown() {
        if ($(window).width() >= 991) {
            $(".nav__list li:not(:first-child)").hover(
                function() {
                    $(this).find(".drop-down__menu").stop(true, true).fadeIn(200);
                },
                function() {
                    $(this).find(".drop-down__menu").stop(true, true).fadeOut(200);
                }
            );

            $(".drop-down__menu").hover(
                function() {
                    $(this).stop(true, true).fadeIn(200);
                },
                function() {
                    $(this).stop(true, true).fadeOut(200);
                }
            );
        } 
    }

    handleDropdown();

    $(window).resize(handleDropdown);
    // $(window).reload(handleDropdown);

    $("#show-detail-btn").click(function() {
      $("#show-detail-content").slideToggle();
    });

    const params = new URLSearchParams(window.location.search);
    const urlParams = params.get('tab');

    setTimeout(function(){
      if(urlParams == 'configurator'){
        $('#js-slider-config').addClass('is-active');
        $('.slider__step-config').addClass('is-active');
        $('.slider-bg-overlay').addClass('is-active');
        $(html).addClass('is-slider-active');
      }
    },1000);

    if(urlParams == 'chatbox'){
      $('#heygen-streaming-embed').show();
    }

    if(urlParams == 'calendly'){
      console.log('ewgrehrehtrh');
      $('.js-calendly-popup').addClass('popup-is-open');
      $('.js-calendly-popup').css('display', 'block');
      $(html).addClass('is-slider-active');
    }
    
    setTimeout(function(){
      const urlParamsType = params.get('type');
      if(urlParamsType){
        $('input[name="orderPreference"]').each(function(){  
          var option2 = $(this).attr('id');
          if( option2 == urlParamsType ){
             $(this).attr('checked', 'checked');        
          }     
        })
      }
    },1000);

});

if($(window).width() < 991) {
  $(".submenu-open").on("click", function (e) {
    e.preventDefault();
    let $dropdown = $(this).next(".drop-down__menu");
  
    if ($dropdown.is(":visible")) {
        $dropdown.stop(true, true).slideUp(200);
        $(this).removeClass("open");
    } else {
        $(".drop-down__menu").not($dropdown).slideUp(300); 
        $dropdown.stop(true, true).slideDown(300);
        $(".nav__list li:not(:first-child) > a").removeClass("open");
        $(this).addClass("open");
    }
    $(".nav").animate({ scrollTop: 0 }, 200);
  });
}

/* nav chat button */
$('.chat-btn a').click(function (){
  $('#heygen-streaming-embed').show();

  $.ajax({
    url : "https://checkout.chinuki.de/heygen_streaming/",
    method : "POST",
    success : function(data) {
       console.log("Sent user data email to backend")
    },
    error : function(data) {
      console.log('error');
    }  
  }); 
});


$(document).on('click', '.chat-close', function() {
  $('#heygen-streaming-embed').hide();
});

/* end nav chat button */


/* =============================================
  configure box 
  ============================================= */
 
  /* config slider */
  var slideConfig = document.querySelector('#js-slider-config');
  var sliderConfigBg = document.querySelector('.slider-bg-overlay');
  var slideConfigBtns = document.querySelectorAll('.js-config-slider');
  var sliderConfigClose = document.querySelector('#js-close-config');
  var sliderConfigReturnBtns = document.querySelectorAll('.js-config-return');
  var htmlBody = document.querySelectorAll('body')[0];
  var kidsModal = document.querySelector('#js-modal-kids');
  const loginPopup = document.querySelector('.js-login-popup');
  var sendQuote = document.querySelector('.send-quote-btn');
  var sendQuoteStep = document.querySelector('.send-quote-step');
  var cartStep = document.querySelector('.js-cart-step');
  var trialBox = document.querySelector('.trial-box-btn');
  var trialBoxStep = document.querySelector('.trial-box-step');
  

  if(slideConfigBtns) {
    // slideConfigBtns.forEach(function(slideConfigBtn,index) {
    //   slideConfigBtn.addEventListener('click',function(){
    //     if(slideConfig.classList.contains('is-active')) {
    //       slideConfig.classList.remove('is-active');
    //       sliderConfigBg.classList.remove('is-active');
    //       html.classList.remove('is-slider-active');
          
    //     }
    //     else {
    //       slideConfig.classList.add('is-active');
    //       sliderConfigBg.classList.add('is-active');
    //       html.classList.add('is-slider-active');
    //     }
    //     if(header.classList.contains('nav-is-open')) {
    //       html.classList.remove('nav-is-open');
    //       header.classList.remove('nav-is-open');
    //     }
    //     if(loginPopup.classList.contains('popup-is-open')) {
    //       loginPopup.classList.remove('popup-is-open');
    //       loginPopup.style.display = "none";
    //     }
    //   });
    // });
  }

  /* Config Close button slider */
  if(sliderConfigClose) {
    sliderConfigClose.addEventListener('click',function(){
      slideConfig.classList.remove('is-active');
      sliderConfigBg.classList.remove('is-active');
      html.classList.remove('is-slider-active');
      // console.log('click');
        $(".rotate-image").removeClass("rotateImage");
        $(".rotate-image").show();
        $('.confetti-image').hide();
    });
  }

  /* Config background click close slider */
  if(sliderConfigBg) {
    sliderConfigBg.addEventListener('click',function(){
      slideConfig.classList.remove('is-active');
      sliderConfigBg.classList.remove('is-active');
      html.classList.remove('is-slider-active');
    });
  }

  /* Config return button close slider */
  if(sliderConfigReturnBtns) {
    sliderConfigReturnBtns.forEach(function(sliderConfigReturn,index) {
      sliderConfigReturn.addEventListener('click',function(){
        slideConfig.classList.remove('is-active');
        sliderConfigBg.classList.remove('is-active');
        html.classList.remove('is-slider-active');
      });
    });
  }

  /* Send Quote slider */
  if(sendQuote){
    sendQuote.addEventListener('click',function(){
      cartStep.classList.remove('is-active');
      sendQuoteStep.classList.add('is-active');
      $('.send-quote-step .slider__body').show();
      $('.send-quote-step .slider__footer').show();
      $('.quote-form-successfull-msg').hide();
    });
  }

  /* Trial Order slider */
  if(trialBox){
    trialBox.addEventListener('click',function(){
      cartStep.classList.remove('is-active');
      trialBoxStep.classList.add('is-active');
    });
  }

document.addEventListener('DOMContentLoaded', function () {

  // Close configure when click outside start
  // console.log(configModal);
//   if(configModal) {
//     configModal.forEach(function(configModalItem,index) {
//       configModalItem.addEventListener('click',function(){
//         console.log(index);
//       });
//     })
// }

    // if(slideConfigBtns) {
    //   document.body.addEventListener('mousedown', (e) => {
    //     let isClickInsideSlideConfigBtns = slideConfigBtns1.contains(e.target);
    //     let isClickInsideSlideConfig = slideConfig.contains(e.target);
    //     // let isClickInsideSlideConfig = kidsModal.contains(e.target);

    //     if (!isClickInsideSlideConfigBtns && !isClickInsideSlideConfig && !document.querySelector('#js-modal-kids').contains(e.target) && !document.querySelector('#js-modal-meals').contains(e.target) && !document.querySelector('#js-modal-preference').contains(e.target) && !document.querySelector('#js-modal-add-preference').contains(e.target) && !document.querySelector('#js-modal-device').contains(e.target) && !document.querySelector('#js-order-preference-device').contains(e.target)) {
    //       if(slideConfig.classList.contains('is-active')) {
    //         slideConfig.classList.remove('is-active');
    //         sliderConfigBg.classList.remove('is-active');
    //         html.classList.remove('is-slider-active');
    //       }
    //     }
    //   });
    // }
    // Close configure when click outside End


 /* Config box number of kids selectbox */
 const portionSelectItem = document.querySelectorAll('#js-portion-select li');
 const portionInput = document.querySelector('#js-portion-selected');
 const portionText =  document.querySelector('#js-portion-text');
 const numberKidsVal = document.querySelector('#js-portion-selected-text');
 const portionSelectToggle = document.querySelector('#js-portion-toggle');

 portionSelectToggle.addEventListener('mouseover', (event) => {
  portionSelectToggle.classList.add('is-open');
 });

  portionSelectToggle.addEventListener('mouseout', (event) => {
    portionSelectToggle.classList.remove('is-open');
  });
 

  if(portionSelectItem) {
    portionSelectItem.forEach(function(portionItem,index) {
      portionItem.addEventListener('click',function(){
        let portionSelectedText = this.dataset.portion;
        portionInput.value = portionItem.innerHTML;
        numberKidsVal.innerHTML = portionItem.innerHTML;
        portionText.innerHTML = portionSelectedText;
        if(portionSelectToggle.classList.contains('is-open')) {
          setTimeout(function(){
            portionSelectToggle.classList.remove('is-open');
          },100);
        }
      })
    });
  }

  /* config meals selectbox */
  const mealSelectedItem = document.querySelectorAll('#js-meals-select li');
  const mealVal = document.querySelector('#js-meal-selected-text');
  const mealInput = document.querySelector('#js-meals-selected');
  const mealSelectToggle = document.querySelector('#js-meal-toggle');

  mealSelectToggle.addEventListener('mouseover', (event) => {
    mealSelectToggle.classList.add('is-open');
  });
  
  mealSelectToggle.addEventListener('mouseout', (event) => {
    mealSelectToggle.classList.remove('is-open');
  });

  if(mealSelectedItem) {
    mealSelectedItem.forEach(function(mealItem,index) {
      mealItem.addEventListener('click',function(){
        mealInput.value = mealItem.innerHTML;
        mealVal.innerHTML = mealItem.innerHTML;
        if(mealSelectToggle.classList.contains('is-open')) {
          setTimeout(function(){
            mealSelectToggle.classList.remove('is-open');
          },500);
        }
      });
    });
  }


  const sousRadios = document.querySelectorAll('input[name="devices"]');
  const sousImg = document.querySelector('#js-sous-img');

  /* if sous is not selected */
  if(sousRadios) {
    sousRadios.forEach(function(sousRadio,index) {
      sousRadio.addEventListener('click',function(){
        if(sousRadio.id == 'noDevice') {
          sousImg.style.display = 'none';
        }
        if(sousRadio.id == 'withDevice') {
          sousImg.style.display = 'block';
        }
      });
    });
  }

  /* ================================
  popup config
  =================================== */

  /* number of kids popup */
  var numberKidsInfoBtn = document.querySelector('.js-config-kids-info');
  if(numberKidsInfoBtn) {
    numberKidsInfoBtn.addEventListener('click', function() {
      new Modal({el: document.getElementById('js-modal-kids')}).show(); 
    });
  }

  /* zipcode popup */
  var numberKidsInfoBtn = document.querySelector('.js-config-zipcode-info');
  if(numberKidsInfoBtn) {
    numberKidsInfoBtn.addEventListener('click', function() {
      new Modal({el: document.getElementById('js-modal-zipcode')}).show(); 
    });
  }

  /* meals popup */
  var mealsInfoBtn = document.querySelector('.js-config-meals-info');
  if(mealsInfoBtn) {
    mealsInfoBtn.addEventListener('click', function() {
      new Modal({el: document.getElementById('js-modal-meals')}).show(); 
    });
  }

  /* meal preference popup */
  var preferenceInfoBtn = document.querySelector('.js-config-preference-info');
  if(preferenceInfoBtn) {
    preferenceInfoBtn.addEventListener('click', function() {
      new Modal({el: document.getElementById('js-modal-preference')}).show(); 
    });
  }

  /* additional meals preference popup */
  var addPreferenceInfoBtn = document.querySelector('.js-config-add-preference-info');
  if(addPreferenceInfoBtn) {
    addPreferenceInfoBtn.addEventListener('click', function() {
      new Modal({el: document.getElementById('js-modal-add-preference')}).show(); 
    });
  }
  
  /* device wide popup */
  var deviceInfoBtn = document.querySelector('.js-config-device-info');
  if(deviceInfoBtn) {
    deviceInfoBtn.addEventListener('click', function() {
      new Modal({el: document.getElementById('js-modal-device')}).show(); 
    });
  }

  /* order preference popup */
  var orderPreferenceInfoBtn = document.querySelector('.js-config-order-preference-info');
  if(orderPreferenceInfoBtn) {
    orderPreferenceInfoBtn.addEventListener('click', function() {
      new Modal({el: document.getElementById('js-order-preference-device')}).show(); 
    });
  }

  /* delivery summary popup */
  var deliverySummaryBtn = document.querySelector('.js-delivery-info');
  if(deliverySummaryBtn) {
    deliverySummaryBtn.addEventListener('click', function() {
      new Modal({el: document.getElementById('js-delivery-summary')}).show(); 
    });
  }

/* Trial order step 1 summary popup */
var trialstep1Btn = document.querySelector('.trial-order-step1-info');
  if(trialstep1Btn) {
    trialstep1Btn.addEventListener('click', function() {
    new Modal({el: document.getElementById('js-modal-trial-step1')}).show(); 
  });
}

/* Trial order step 2 summary popup */
var trialstep2Btn = document.querySelector('.trial-order-step2-info');
  if(trialstep2Btn) {
    trialstep2Btn.addEventListener('click', function() {
    new Modal({el: document.getElementById('js-modal-trial-step2')}).show(); 
  });
}

/* Trial order step 3 summary popup */
var trialstep3Btn = document.querySelector('.trial-order-step3-info');
  if(trialstep3Btn) {
    trialstep3Btn.addEventListener('click', function() {
    new Modal({el: document.getElementById('js-modal-trial-step3')}).show(); 
  });
}

  /* go to cart */
  var goToCartBtn = document.querySelector('.js-go-to-cart');
  var backToConfigBtn = document.querySelector('.js-back-to-selection');
  //var cartStep = document.querySelector('.js-cart-step');
  var configStep = document.querySelector('.js-config-step');

  goToCartBtn.addEventListener('click',function(){
    //cartStep.classList.add('is-active');
    configStep.classList.remove('is-active');
  });

  // backToConfigBtn.addEventListener('click',function(){
  //   cartStep.classList.remove('is-active');
  //   slideConfig.classList.remove('is-active');
  //   //configStep.classList.add('is-active');
  // });


});
$(document).ready(function() {
  // Open popup when any element with the class '.js-config-slider' is clicked
  // Check if the input field with the specified classes is empty or not

  // Attach the 'input' event listener to the input field with the specified classes
  // $('.sidebar-kinder').on('input', function() {
  //   // Check if the input field is empty or not
  //   if ($(this).val() === "") {
  //     $(".submit-button-br").attr('disabled', true)
  //   } else {
  //     $(".submit-button-br").attr('disabled', false)
  //   }
  // });
  $('.sidebar-kinder').on('input', function() {
    // Remove unwanted characters (+, -) and enforce a maximum of 3 digits
    let sanitizedValue = $(this).val().replace(/[+-]/g, '').slice(0, 3);
    $(this).val(sanitizedValue);

    // Check if the input field is empty or not
    if (sanitizedValue === "") {
        $(".submit-button-br").attr('disabled', true);
    } else {
        $(".submit-button-br").attr('disabled', false);
    }
});


  $('.js-config-slider').click(function() {
    // console.log("calll.....");

  $(html).addClass('js equalizer-active is-slider-active');
  $(".slider-bg-overlay").addClass('is-active');
  $('#js-slider-config').addClass('is-active');
  $('.js-config-step').addClass('is-active');
  $(html).addClass('js equalizer-active is-slider-active');
  $(".slider-bg-overlay").addClass('is-active');
  $(".slider__body").scrollTop(0);

   //$('.slider__body--popup').removeClass('hidden-popup'); // Remove 'hidden-popup' class to show the popup
    // Check if the input has any value (this also ensures it's a number since it's of type "number")
    // if (value === '') {
    //   $('.kids-popup-btn').css('pointer-events', 'none');  // Disable button if input is empty
    //   return false; // Prevent any further action (e.g., form submission or event propagation)
    // } else {
    //   $('.kids-popup-btn').css('pointer-events', 'all');
    //   return true; // Enable button if input is not empty
    // }
  });
  // Kids popup button click event
  $('.kids-popup-btn').click(function() {

    var allFilled = true;
    $(".postal-code").each(function() {
      if ($(this).val() === "") {
        allFilled = false;
      }
    });
    if (!allFilled) {
      $('#error-message').text('Please enter a postal code.').show();
    } else {
      $(".submit-button-br").attr('disabled', true);
      $('#error-message').hide();
      // console.log("calll.....");
      $('.slider__body--popup').removeClass('hidden-popup'); // Remove 'hidden-popup' class to show the popup

      // Handle other logic here
      var above30ValueAttr = $(".form__children-title input").attr('data-above30-value');
      // console.log('above30ValueAttr=', above30ValueAttr);

      // Split the string by commas and convert to an array of numbers
      var above30Values = above30ValueAttr.split(',').map(Number);
      // console.log('above30Values=', above30Values);

      // Check the under30Value
      var under30Value = parseInt($('.form__children-title input').val(), 10);
      // console.log('under30Value=', under30Value);

      // if (under30Value < 4) {
      //   // Your logic for under30Value < 4
      // } else {
      //   $('.slider--config').addClass("is-active");
      // }

      var minChilderQunatiy = $(".form__children-title input").attr('min-childern');
      var maxChilderQunatiy = $(".form__children-title input").attr('max-childern');

      // Check if under30Value is in the above30Values or is greater than 30
      if (under30Value < minChilderQunatiy || under30Value > maxChilderQunatiy){
        $('.last-submit-button').removeClass('final-cart-btn');
        $('.last-submit-button').addClass('inquiry-form-submit-btn');
        $('.configurator30plus-main').show();
        $('.config-bottom-under-30').hide();
        $('.order-summary').hide();
        $('.delivery-summary').hide();
        $('.config-bottom-above-30').show();
        $('.js-config-step').removeClass('is-active');
        $('.js-cart-step').removeClass('is-active');
        $('.product-third-step-config').addClass('is-active');
        $('.slider--config').addClass("is-active");
        $('.step-four-wrap .slider__step').addClass('is-active');
        $('.step-six-wrap').css('display', 'none');
        $('.step-six-wrap .slider__step').removeClass('is-active');
      } else {
        $('.last-submit-button').addClass('final-cart-btn');
        $('.configurator30plus-main').hide();
        $('.last-submit-button').removeClass('inquiry-form-submit-btn');
        $('.order-summary').show();
        $('.delivery-summary').show();
        $('.config-bottom-under-30').show();
        $('.config-bottom-above-30').hide();
        $('.js-cart-step').addClass('is-active');
        $('.product-third-step-config').removeClass('is-active');
        $('.js-config-step').addClass('is-active');
        $('.step-four-wrap .slider__step').removeClass('is-active');
        $('.step-six-wrap').css('display', 'block');
        $('.step-six-wrap .slider__step').addClass('is-active');
      }

      let configData = {};
      let postalCode = '';
      $('.postal-code').each(function() {
          postalCode += $(this).val();
      });
      configData['Name_Kindertagespflege'] = $("#js-portion-selected").val();
      configData['PLZ'] = postalCode;
      configData['Anzahl_der_Wochengerichte'] = $("#js-meals-select li.active").text();  
      configData['Praferenz_der_Gerichte'] = $('input[name="mealPreference"]:checked').attr('data-preference-value');
      configData['Zusatzliche_Praferenz'] = $('input[name="addPrefernce"]:checked').attr('data-addi-preference-value');
      configData['Sous_Vide_Gerat'] = $('input[name="devices"]:checked').attr('data-device-attr');
      configData['Bestellvariante'] = $('input[name="orderPreference"]:checked').attr('id');
      configData['Abrechnung_der_verpflegung'] = $('input[name="meals-accounting"]:checked').attr('data-meal-accounting');
      
      // console.log('configData ',configData);
      $.ajax({
        url : "https://checkout.chinuki.de/availability/region/inquiry/",
        method : "POST",
        dataType : "JSON",
        contentType: "application/json; charset=utf-8",
        data :JSON.stringify(configData),
        success : function(data) {
          // console.log('sended form data ',data)
          // console.log("Sent email to backend")
        },
        error : function(data) {
          console.log('error');
        }  
      });
      
    }
  });

  // Close the popup when the element with the class '.js-close-config' is clicked
  $('.js-close-config').click(function() {
    $('.slider__body--popup').addClass('hidden-popup'); // Add 'hidden-popup' class to hide the popup
    $('.slider--config').removeClass("is-active");
    $(".slider-bg-overlay").removeClass("is-active");
  });
  $('.slider-bg-overlay').click(function () {
    $('.slider-bg-overlay').removeClass('is-active'); // Hide the overlay
    $('.slider__body--popup').addClass('hidden-popup'); // Hide the slider
    // $(".slider__step.is-active").removeClass("is-active");
    $(".slider--config").removeClass("is-active");
    $(".js-cart-step").removeClass('is-active');
    $('.step-four-wrap .slider__step').removeClass('is-active');
    $('.step-six-wrap').removeClass('is-active-show');
  });
});



function checkConditions() {  
  var allPostalCodesFilled = $('.postal-code').toArray().every(input => $(input).val() !== '');
  var sidebarKinderFilled = $('.sidebar-kinder').val() !== '';
  var sidebarKinderZero = $('.sidebar-kinder').val() > 0;

  if (allPostalCodesFilled && sidebarKinderFilled && sidebarKinderZero) {
        
        $(".bottom-header").show();
        $(".rotate-image").addClass("rotateImage");
        $("#error-message2").hide();
  
        var above30ValueAttr = $(".form__children-title input").attr('data-above30-value');
        var above30Values = above30ValueAttr.split(',').map(Number);
        var under30Value = parseInt($('.form__children-title input').val(), 10);
        $('.bottom-header').html('<h3><span>Wir prüfen ob eine Chinuki- oder </span><span>zertifizierte Partner-Menülinie </span><span>in Ihrer Region verfügbar ist...</span></h3>');
        // if (above30Values.includes(under30Value) || under30Value > 30) {
        //     $('.bottom-header').html('<h3><span>Wir prüfen ob eine Chinuki- oder </span><span>zertifizierte Partner-Menülinie </span><span>in Ihrer Region verfügbar ist...</span></h3>');
        // } else {
        //     $('.bottom-header').html('<h3><span>Chinuki ist in Ihrer Region verfügbar!</span><span>Im nächsten Schritt können Sie Ihre Menülinie und Präferenzen auswählen.</span></h3>');
        // }
  
        // Show confetti and enable submit after a delay
        setTimeout(() => {
          let allzip_filled = true;
          let allzip_filled_zero = false;
          
          $('.postal-code').each(function() {
              if ($(this).val() === '') {
                allzip_filled = false;
                  return false;
              }

              // Check if zipcode field has all 0 values
              if ($(this).val().replace(/0/g, '') !== '') {
                allzip_filled_zero = true;
              }
          });
          if(allzip_filled && allzip_filled_zero){

            $('.js-go-to-cart').attr('disabled', false);
            $('.js-go-to-cart').removeClass('submit-button-br-togg');
            $('#error-message').text('').hide();
          // console.log('--+++++++---')
          }else{
            $('#error-message').text('Bitte geben Sie eine gültige Postleitzahl ein.').show();
            $('.js-go-to-cart').attr('disabled', true);
            $('.js-go-to-cart').addClass('submit-button-br-togg');
          }
        }, 2000);      
  } else {
      $('.js-go-to-cart').attr('disabled', true);
      $('.js-go-to-cart').addClass('submit-button-br-togg');
      $(".submit-button-br").attr('disabled', true).addClass('submit-button-br-togg');

      if(sidebarKinderZero && sidebarKinderFilled){
        $("#error-message2").hide();
      }else{
        $("#error-message2").show();
        return true;
      }
  }

}

// Attach event listeners
$('.postal-code').on('input', function () {
  var currentInput = $(this);
  var value = currentInput.val();

  // Allow only digits and restrict length to 1
  currentInput.val(value.replace(/[^0-9]/g, '').substring(0, 1));

  // Move focus to the next input if this field is filled
  if (currentInput.val() !== '') {
      var nextInput = $('.postal-code').filter(function () {
          return $(this).val() === '';
      }).first();
      if (nextInput.length) {
          nextInput.focus();
      }
  }

  checkConditions();
});

$('.sidebar-kinder').on('input change', checkConditions);


// $('.postal-code').on('input', function() {
//   var currentInput = $(this);
//   var value = currentInput.val();
//   this.value = this.value.replace(/[^0-9]/g, '');
//   // Only allow a single digit to be entered
//   if (value.length > 1) {
//       currentInput.val(value.charAt(0)); // Keep only the first digit
//   }

//   // Move focus to the next input when a digit is entered
//   if (currentInput.val().length === 1) {
//       var nextInput = currentInput.next('.postal-code');
//       // if ($('.postal-code').toArray().every(input => $(input).val() !== '') && $('.sidebar-kinder').val() !== '') {
//         if ($('.postal-code').toArray().every(input => $(input).val() !== '') && $('.sidebar-kinder').val() !== '') {
//         $(".bottom-header").show();
//         $(".rotate-image").addClass("rotateImage");
    
//         var above30ValueAttr = $(".form__children-title input").attr('data-above30-value');
//         var above30Values = above30ValueAttr.split(',').map(Number);
//         var under30Value = parseInt($('.form__children-title input').val(), 10); // Ensure under30Value is a number
    
//         if (above30Values.includes(under30Value) || under30Value > 30) {
//             $('.bottom-header').html('<h3><span> Wir prüfen ob eine Chinuki- oder </span><span> zertifizierte Partner-Menülinie </span><span> in Ihrer Region verfügbar ist... </span></h3>');
//             $(".rotate-image").addClass("rotateImage");
//             setTimeout(() => {
//                 $(".rotate-image").hide();
//                 $('.confetti-image').show();
//                 $(".submit-button-br").attr('disabled', false);
//                 $(".submit-button-br").removeClass('submit-button-br-togg');
//             }, 3000);
//         } else
    
//         $(".bottom-header").show();
//         $(".rotate-image").addClass("rotateImage");
//         var above30ValueAttr = $(".form__children-title input").attr('data-above30-value');
//         var above30Values = above30ValueAttr.split(',').map(Number);
//         var under30Value = parseInt($('.form__children-title input').val(), 10); // Ensure under30Value is a number
    
//         if (above30Values.includes(under30Value) || under30Value > 30) {
//         $('.bottom-header').html('<h3><span> Wir prüfen ob eine Chinuki- oder </span><span> zertifizierte Partner-Menülinie </span><span> in Ihrer Region verfügbar ist... </span></h3>');
//         $(".rotate-image").addClass("rotateImage");
//         setTimeout(() => {
//           $(".rotate-image").hide();
//           $('.confetti-image').show();
//           $(".submit-button-br").attr('disabled', false)
//           $(".submit-button-br").removeClass('submit-button-br-togg')
//         }, 3000)
//     }else{
//         $('.bottom-header').html('<h3><span>Chinuki ist in Ihrer Region verfügbar!</span><span>Im näachsten Schritt können Sie Ihre Menülinie und Präferenzen auswählen.</span></h3>');
//         $(".rotate-image").addClass("rotateImage");
//         setTimeout(() => {
//           $(".rotate-image").hide();
//           $('.confetti-image').show();
//           $(".submit-button-br").attr('disabled', false)
//           $(".submit-button-br").removeClass('submit-button-br-togg')
//         }, 3000)
        
//     }
     
//     } else {
//         var nextInput = currentInput.next('.postal-code');
//         if (nextInput.length) {
//             nextInput.focus();
//         }
//     }
//       if (nextInput.length) {
//           nextInput.focus();
//       }
//   }
  
// });

// Move focus to the previous input when backspace is pressed (for postal code inputs only)
$('.postal-code').on('keydown', function(event) {
  var currentInput = $(this);
  // Check if Backspace is pressed and the current input is empty
  if (event.key === "Backspace" && currentInput.val() === "") {
      var prevInput = currentInput.prev('.postal-code');
      if (prevInput.length) {
          prevInput.focus();
      }
  }
});

  



  

$(document).on('click', '.js-back-to-selection', function(){
  $(document).find('.step-six-wrap').removeClass('is-active-show').css('display', 'none');
  $('.send-quote-step').removeClass('is-active');
  $('.trial-box-step').removeClass('is-active');
})